var map = {
	"./3.png": 488,
	"./4.png": 2631,
	"./5.png": 3134,
	"./7.png": 5052,
	"./custom_cards.svg": 1068,
	"./easy_to_use_2.png": 7470,
	"./easy_to_use_2.svg": 3762,
	"./easy_to_use_2_square.png": 7678,
	"./ecards.png": 8817,
	"./manage_events.png": 7320,
	"./manage_events.svg": 8840,
	"./save_time_money.png": 3343,
	"./save_time_money.svg": 7215,
	"./save_time_money_square.png": 8389,
	"./watoa_huduma.png": 1098,
	"./watoa_huduma.svg": 6776
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8483;